export default __webpack_public_path__ + "static/media/green.080ba181.webp";